export const LOGIN_ERROR_TYPES = {
    INVALID_USERNAME: 'INVALID_USERNAME',
    INVALID_PASSWORD: 'INVALID_PASSWORD',
    UNVERIFIED_ACCOUNT: 'UNVERIFIED_ACCOUNT',
    BLOCKED_ACCOUNT: 'BLOCKED_ACCOUNT'
}
